// auth.guard.ts
import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {AuthService} from '../services/auth.service';
import {Observable, map, take, tap, of, catchError} from 'rxjs';
import {TranslateService} from "@ngx-translate/core";

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private _translateService: TranslateService
  ) {}

  canActivate(): Observable<boolean> {
    return this.authService.userInfo$.pipe(
      take(1), // Wir brauchen nur den aktuellen Wert
      map(userInfo => {
        if (userInfo && userInfo.groups && userInfo.groups.includes('admin')) {
          return true;
        }
        const currentLang = this._translateService.currentLang || 'en';
        this.router.navigate([`/${currentLang}`]);
        return false;
      }),
      catchError(err => {
        const currentLang = this._translateService.currentLang || 'en';
        this.router.navigate([`/${currentLang}`]);
        return of(false);
      })
    );
  }
}
